import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from '../../Authentication/Context/AuthProvider';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID!;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false
        },
    },
});

interface AppProviderProps {
    children: React.ReactNode;
}

function AppProvider({ children }: AppProviderProps) { 
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <AuthProvider>
                        <GoogleOAuthProvider clientId={clientId}>
                            <CssBaseline />
                            {children}
                        </GoogleOAuthProvider>
                    </AuthProvider>
                </LocalizationProvider>
            </ThemeProvider>
        </QueryClientProvider>
    );
};

export default AppProvider;